import * as constants from '../constants';
/**
 * @ngdoc service
 * @name proximus.core.storage.service:StorageService
 * @description
 * # StorageService
 *  Retrieves, adds and removes objects using the provided strategies
 */
export default class StorageService {
    constructor(configurationService) {
        this.configurationService = configurationService;
        this._configurationService = this.configurationService;
    }
    /**
     * retrieves object from storage depending on storage strategy, tries all storage strategies if not provided with a specific one0
     * @memberof proximus.core.storage.service:StorageService
     * @param {String} key
     * @param {String} storage location (local or session)
     * @returns {Promise} promise
     */
    getItem(key, storageStrategy) {
        // Note: core should implement a storage service that will abstract the use of getItem without providing a strategy
        try {
            const strategies = this._configurationService.getStorageStrategies();
            return strategies[storageStrategy].getItem(key);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    /**
     * sets object to storage depending on storage strategy
     * @memberof proximus.core.storage.service:StorageService
     * @param {String} key
     * @param {Object} object to set
     * @param {String} storage location (local or session)
     * @returns {Promise} promise
     */
    setItem(key, object, storageStrategy) {
        if (storageStrategy === constants.STORAGESTRATEGY.NONE) {
            return Promise.resolve(object);
        }
        try {
            const strategies = this._configurationService.getStorageStrategies();
            return strategies[storageStrategy].setItem(key, object);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    /**
     * removes object from storage depending on storage strategy
     * @memberof proximus.core.storage.service:StorageService
     * @param {String} key
     * @param {String} storage location (local or session)
     * @returns {Promise} promise
     */
    removeItem(key, storageStrategy) {
        if (storageStrategy === constants.STORAGESTRATEGY.NONE) {
            return Promise.resolve();
        }
        try {
            const strategies = this._configurationService.getStorageStrategies();
            return strategies[storageStrategy].removeItem(key);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    /**
     * clears storage depending on storage strategy
     * @memberof proximus.core.storage.service:StorageService
     * @param {String} storage location (local or session)
     * @returns {Promise} promise
     */
    clear(storageStrategy) {
        // Note: core should implement a storage service that will abstract the use of clear without providing a strategy
        try {
            const strategies = this._configurationService.getStorageStrategies();
            return strategies[storageStrategy].clear();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
}
